module.exports = __webpack_public_path__ + "4f0022f25672c7f501c339cbf98d9117.ttf";